import { useTranslation } from '@mint-lib/i18n';
import { Delete } from '@mint-lib/icons';
// TODO: RichTooltip, RichTooltipContent and RichTooltipTrigger must be imported from '@mint-lib/tw-components/patterns',
// not from '@mint-lib/tw-components'. The patterns RichTooltipContent already renders the title (h6) and description
// (body text) with the correct typography, so pass them via the `title` and `description` props instead of custom
// children/typography. Optional `primaryButtonProps` / `secondaryButtonProps` render action buttons. It defaults to
// side="top" with a flex-col gap-4 layout, so drop redundant className/side overrides.
import {
  Button,
  RichTooltip,
  RichTooltipContent,
  RichTooltipTrigger,
} from '@mint-lib/tw-components';

interface Props {
  isAllowedRemove: boolean;
  onRemove?: () => void;
}

export const RemoveConnectionButton = ({
  isAllowedRemove,
  onRemove,
}: Props) => {
  const { t } = useTranslation('@mint-lib/connections-ui');

  return (
    <RichTooltip>
      <RichTooltipTrigger>
        <Button
          variant="text"
          className="gap-1"
          color="error"
          onClick={onRemove}
          disabled={!isAllowedRemove}
          aria-disabled={!isAllowedRemove}
          aria-describedby={isAllowedRemove ? undefined : 'remove-hint'}
          data-dd-action-name="Remove Connection"
        >
          <Delete
            className={
              isAllowedRemove ? 'fill-error-dark' : 'fill-text-disabled'
            }
          />
          {t('Remove connection')}
        </Button>
      </RichTooltipTrigger>
      {!isAllowedRemove && (
        <RichTooltipContent
          id="remove-hint"
          className="ui-primary"
          role="tooltip"
        >
          {t(
            'To remove this connection, first disconnect all linked Ad accounts',
          )}
        </RichTooltipContent>
      )}
    </RichTooltip>
  );
};
